/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { absDependencies } from './dependenciesAbs.generated.js';
import { addDependencies } from './dependenciesAdd.generated.js';
import { addScalarDependencies } from './dependenciesAddScalar.generated.js';
import { atanDependencies } from './dependenciesAtan.generated.js';
import { bignumberDependencies } from './dependenciesBignumber.generated.js';
import { cosDependencies } from './dependenciesCos.generated.js';
import { equalDependencies } from './dependenciesEqual.generated.js';
import { invDependencies } from './dependenciesInv.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { multiplyDependencies } from './dependenciesMultiply.generated.js';
import { multiplyScalarDependencies } from './dependenciesMultiplyScalar.generated.js';
import { sinDependencies } from './dependenciesSin.generated.js';
import { subtractDependencies } from './dependenciesSubtract.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createEigs } from '../../factoriesAny.js';
export var eigsDependencies = {
  absDependencies,
  addDependencies,
  addScalarDependencies,
  atanDependencies,
  bignumberDependencies,
  cosDependencies,
  equalDependencies,
  invDependencies,
  matrixDependencies,
  multiplyDependencies,
  multiplyScalarDependencies,
  sinDependencies,
  subtractDependencies,
  typedDependencies,
  createEigs
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesEigs.generated.js
// module id = null
// module chunks = 